new Swiper("#gallery-swiper", {
	slidesPerView: 1,
	spaceBetween: 24,
	pagination: {
		el: "#gallery-pagination",
		type: "fraction",
		renderFraction: (currentClass, totalClass) => {
			return (
				'<span class="' +
				currentClass +
				'"></span>' +
				" / " +
				'<span class="' +
				totalClass +
				' text-primary-300 dark:text-neutral-100"></span>'
			);
		},
	},
	navigation: {
		addIcons: false,
		nextEl: "#gallery-button-next",
		prevEl: "#gallery-button-prev",
	},
	breakpoints: {
		768: {
			slidesPerView: "auto",
		},
	},
});
